import React from "react";
import styled from "styled-components";

const LabelWrapper = styled.div`
  display: inline-block;
  position: relative;
  bottom: 1px;
  line-height: 6px;
  margin-left: 4px;
  background-color: ${({ theme }) => theme.colors.green2};
  padding: 3px 4px;
  border-radius: 10px;
`;

const CaveatLabelSpan = styled.span`
  color: ${({ theme }) => theme.colors.green4};
  display: inline-block;
  position: relative;
  font-weight: 500;
  font-size: 0.5rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const CaveatLabel = ({ children }) => {
  return (
    <LabelWrapper>
      <CaveatLabelSpan>{children}</CaveatLabelSpan>
    </LabelWrapper>
  );
};

export default CaveatLabel;
